module.exports = __webpack_public_path__ + "img/down_new_iphone.a2a0c25a.png";